import { Absence } from '../types/interfaces';

export const AbsenceTemplate: Absence = {
  id: 0,
  name: '',
  shortName: '',
  shouldRemoveShift: false
};
